// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"60e1341f","37":"ac7422bb"}[chunkId] + ".chunk.js";
};